<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-user-star-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Liste des bénéficiaires</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input" placeholder="Rechercher...">
                                <button v-if="searchword" @click="searchword = ''" class="search-clear" aria-label="Effacer"><i class="ri-close-line"></i></button>
                            </div>
                            <button @click="btnajouter" class="ti-btn ti-btn-primary-full">
                                <i class="ri-add-line align-middle"></i><span class="hidden sm:inline">&nbsp;Ajouter</span>
                            </button>
                        </div>
                        <div class="cf-toolbar-meta">
                            <span></span>
                            <div class="cf-perpage">
                                <label>Afficher</label>
                                <div class="cf-select-wrap">
                                    <select v-model="DefaultperPage" class="cf-select--sm">
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                        <option value="200">200</option>
                                        <option value="250">250</option>
                                        <option value="300">300</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body cf-dialog-body--flush">
                        <div class="table-scroll-wrap doc-scroll">
                            <table class="doc-table">
                                <thead>
                                    <tr>
                                        <th class="th" style="width:4rem">N°</th>
                                        <th class="th">Nom et prénom</th>
                                        <th class="th">Téléphone</th>
                                        <th class="th">Adresse</th>
                                        <th class="th th--center" style="width:7rem">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="filterdatatable.length">
                                        <tr class="table-row" v-for="(datavalue,index) in filterdatatable" :key="index">
                                            <td class="td row-number">{{ index+1 }}</td>
                                            <td class="td cf-strong">{{ datavalue.name }}</td>
                                            <td class="td">{{ datavalue.telephone }}</td>
                                            <td class="td">{{ datavalue.adresse }}</td>
                                            <td class="td td--center">
                                                <div class="cf-actions">
                                                    <button @click="btnmodifier(datavalue)" class="cf-iconbtn cf-iconbtn--primary" title="Modifier"><i class="ri-pen-nib-line"></i></button>
                                                    <button @click="btnsuppression(datavalue)" class="cf-iconbtn cf-iconbtn--danger" title="Supprimer"><i class="ri-delete-bin-line"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="5" class="td">
                                                <div class="empty-state">
                                                    <div class="empty-state__icon"><i class="ri-user-search-line"></i></div>
                                                    <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <div class="pagination" v-if="pages.length > 1">
                            <button class="page-btn page-btn--nav" @click="page--" :disabled="page <= 1"><i class="ri-arrow-left-s-line"></i></button>
                            <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                <span v-if="pageNumber === '...'" class="cf-ellipsis">…</span>
                                <button v-else class="page-btn" :class="{ 'page-btn--active': pageNumber === page }" @click="page = pageNumber">{{ pageNumber }}</button>
                            </template>
                            <button class="page-btn page-btn--nav" @click="page++" :disabled="page >= pages.length"><i class="ri-arrow-right-s-line"></i></button>
                        </div>
                        <span v-else></span>
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <modalform ref="modalform"  @closed="load"></modalform>
    <modalformsuppression @closed="load"  ref="modalformsuppression"></modalformsuppression>
</template>

<script>

  //  import modalcustomlib from "@/components/views/pages/gestioncommerciale/modal_customlib";

    const axios =require('axios');

     import modalform from "@/components/views/pages/caisse/beneficiaire/form";
    import modalformsuppression from "@/components/views/pages/caisse/beneficiaire/formsuppression";


    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
          /*  searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

                // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
                // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

            }*/

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                /*if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.removeline===parseFloat(t.searchtrierletableau)

                    })

                }*/


                if (this.searchword!==''){
                    let t=this;



                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())


                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalform,modalformsuppression


        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                otherdata:[],
                listedupersonnel:[],
                datainputlibelleforms:[],
                datatiers:[],
                customlibelleforms:{},
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                indexbutton:'1d',





                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


            btnajouter(){


                let mname

                let  Item= {
                    pid:'',representant:'',
                    adresse:'',
                    telephone:'',
                }


                mname="Enregistrer un bénéficiaire"

                this.$refs.modalform.show(mname,"add",Item);

            },


            async load(){

                this.isdisplay=true;

                        this.$store.dispatch('lancerchargement',true)
                const t = this;

                this.typedoc="bef"


                let url=process.env.VUE_APP_API_URL+'/egl745874pbenefdef771714dfe/benef/all/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.datatable=res.data.m;
                             t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            btnmodifier(value){

                let mname

                let  Item= {
                    pid:value.pid,representant:value.name,
                    adresse:value.adresse,
                    telephone:value.telephone,
                }


                mname="Modification du bénéficiaire "+value.name

                this.$refs.modalform.show(mname,"update",Item);

            },
             btnsuppression(value){

                if (value.useline===1 || value.useline==='1'){

                    toastr['error']( "Impossible de supprimer cette ligne. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT SUPPRIMER LE BENEFICIAIRE "+value.name+" ?";

                this.$refs.modalformsuppression.show(titlemodal,value);

            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },



            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal

                this.indexbutton='1d';
                this.datatable=[];

                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-body--flush { padding:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; gap:0.6rem; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:center; }
.search-wrap { position:relative; flex:1; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.cf-toolbar-meta { display:flex; align-items:center; justify-content:space-between; margin-top:0.7rem; gap:0.75rem; flex-wrap:wrap; }
.cf-perpage { display:flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); }
.cf-select-wrap { position:relative; }
.cf-select--sm { appearance:none; height:34px; padding:0 28px 0 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

/* Table */
.table-scroll-wrap { overflow:auto; }
.doc-scroll { max-height:60vh; }
.doc-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:640px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.6rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.td--center { text-align:center; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }

/* Icon action buttons */
.cf-actions { display:inline-flex; align-items:center; gap:4px; justify-content:center; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

/* Pagination */
.pagination { display:flex; align-items:center; gap:4px; }
.cf-ellipsis { padding:0 4px; color:var(--cf-faint); }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.doc-scroll::-webkit-scrollbar { width:6px; height:6px; }
.doc-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .doc-scroll { max-height:64vh; } }
</style>